import apiClient from '@/api/axiosClient';

// ===== Schema types =====

export interface Schema {
  name: string;
  hidden: boolean;
}

export interface CreateSchemaRequest {
  schemaName: string;
  hide: boolean;
}

export interface UpdateSchemaRequest {
  schemaName: string;
  hide: boolean;
}

// ===== Table types =====

export interface TableObject {
  schemaName: string;
  objectName: string;
  tableDefinitionId: number;
}

// ===== Schema operations =====

/**
 * Hent alle skjemaer
 */
export async function fetchSchemas (signal?: AbortSignal): Promise<Schema[]> {
  const response = await apiClient.get<Schema[]>('v2/database/system/schemas', { signal });
  return response.data;
}

/**
 * Opprett nytt skjema
 */
export async function createSchema (
  schemaName: string,
  signal?: AbortSignal
): Promise<Schema[]> {
  const response = await apiClient.post<Schema[]>(
    'v2/database/system/schemas',
    { schemaName, hide: false },
    { signal }
  );
  return response.data;
}

/**
 * Oppdater skjema (skjul/vis)
 */
export async function updateSchema (
  schemaName: string,
  hide: boolean,
  signal?: AbortSignal
): Promise<Schema[]> {
  const response = await apiClient.put<Schema[]>(
    'v2/database/system/schemas',
    { schemaName, hide },
    { signal }
  );
  return response.data;
}

/**
 * Slett skjema
 */
export async function deleteSchema (
  schemaName: string,
  signal?: AbortSignal
): Promise<Schema[]> {
  const response = await apiClient.delete<Schema[]>(
    'v2/database/system/schemas',
    { params: { schemaName }, signal }
  );
  return response.data;
}

// ===== Table operations =====

/**
 * Hent tabeller i et skjema
 */
export async function fetchTables (
  schemaName: string,
  signal?: AbortSignal
): Promise<TableObject[]> {
  const response = await apiClient.get<TableObject[]>(
    'v2/database/system/objects',
    { params: { schemaName }, signal }
  );
  return response.data;
}

